import { render, staticRenderFns } from "./BigPromo.vue?vue&type=template&id=6bbc2d20&scoped=true"
import script from "./BigPromo.vue?vue&type=script&lang=js"
export * from "./BigPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc2d20",
  null
  
)

export default component.exports